module.exports = __webpack_public_path__ + "4bfd50cd6788e104db5213b726095b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/tiyan/tiyan3.jpg
// module id = 1232
// module chunks = 0